import { CloseIcon } from '@ordr-as/icons'
import ReactTooltip from 'react-tooltip'

type ChipProps = {
    size: 'small' | 'medium'
    text: string
    closeButtonTooltip?: string
    onClose?: () => void
}

const Chip = (props: ChipProps) => {
    const { size, text, closeButtonTooltip, onClose } = props

    return (
        <div
            className={`flex align-center text-brand-white text-bold bg-brand-primary rounded-[3px] mr-2 ${
                size === 'small' ? 'text-xs' : 'text-sm'
            }`}
        >
            <div className={`py-1 pl-2 ${onClose ? 'pr-1' : 'pr-2'}`}>{text}</div>
            {onClose && (
                <>
                    <div
                        onClick={onClose}
                        className="flex flex-col justify-center pr-2 rounded-r-[3px] hover:bg-orange cursor-pointer"
                        data-tip
                        data-for="remove-favrit-app-button-tooltip"
                    >
                        <CloseIcon className="ml-2 text-brand-white" height={15} width={15} strokeWidth="10px" />
                    </div>
                    <ReactTooltip
                        id="remove-favrit-app-button-tooltip"
                        arrowColor="transparent"
                        effect="solid"
                        padding="1px 4px"
                        className="text-bold !opacity-100"
                    >
                        {closeButtonTooltip ?? 'Close'}
                    </ReactTooltip>
                </>
            )}
        </div>
    )
}

export default Chip
